import React, { FC } from 'react'
import styled from 'styled-components'

import { breakpoints } from '@ads/front-core/constants/breakpoints'
import { lng, TTranslationsKeys } from '@ads/front-core/locales'
import { Icon1 } from './icons/Icon1'
import { Icon2 } from './icons/Icon2'
import { Icon3 } from './icons/Icon3'
import { Icon4 } from './icons/Icon4'
import { Icon5 } from './icons/Icon5'
import { Icon6 } from './icons/Icon6'

const ITEMS: {
  header: TTranslationsKeys
  text: TTranslationsKeys
  Icon: React.ReactElement
}[] = [
  {
    header: 'lppartners:why.box1.header',
    text: 'lppartners:why.box1.text',
    Icon: <Icon1 />,
  },
  {
    header: 'lppartners:why.box2.header',
    text: 'lppartners:why.box2.text',
    Icon: <Icon2 />,
  },
  {
    header: 'lppartners:why.box3.header',
    text: 'lppartners:why.box3.text',
    Icon: <Icon3 />,
  },
  {
    header: 'lppartners:why.box4.header',
    text: 'lppartners:why.box4.text',
    Icon: <Icon4 />,
  },
  {
    header: 'lppartners:why.box5.header',
    text: 'lppartners:why.box5.text',
    Icon: <Icon5 />,
  },
  {
    header: 'lppartners:why.box6.header',
    text: 'lppartners:why.box6.text',
    Icon: <Icon6 />,
  },
]

export const Why: FC = () => (
  <Content>
    <HeaderText>{lng('lppartners:why.header')}</HeaderText>
    <Items>
      {ITEMS.map((item, i) => (
        <Item key={`item-${i}`}>
          <ItemLeft>{item.Icon}</ItemLeft>
          <ItemRight>
            <ItemHeader>{lng(item.header)}</ItemHeader>
            <ItemText>{lng(item.text)}</ItemText>
          </ItemRight>
        </Item>
      ))}
    </Items>
  </Content>
)

const Content = styled.div`
  font-family: Poppins;
  max-width: 1348px;
  margin: 0 auto;
  padding: 60px;
  color: #262a44;
  padding: 80px 60px;

  @media (max-width: ${breakpoints.MOBILE}) {
    padding: 60px 16px 50px 16px;
  }
`

const HeaderText = styled.p`
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 24px;

  @media (max-width: ${breakpoints.MOBILE}) {
    font-size: 26px;
    margin-bottom: 0;
  }
`

const Items = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: ${breakpoints.MOBILE}) {
    grid-template-columns: 1fr;
  }
`

const Item = styled.div`
  display: flex;
  flex-flow: row;
  gap: 24px;
  padding: 42px 0;
  border-bottom: 1px solid #e6e8ed;

  :nth-child(odd) {
    padding-right: 16px;
  }
  :nth-child(even) {
    padding-left: 16px;
  }
  :nth-last-child(-n + 2) {
    border-bottom: 0;
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    padding: 32px 0;
    flex-flow: column;
    gap: 16px;

    :nth-child(odd),
    :nth-child(even) {
      padding-right: 0;
    }
    :nth-last-child(-n + 2) {
      border-bottom: 1px solid #e6e8ed;
    }
    :nth-last-child(-n + 1) {
      border-bottom: 0;
    }
  }
`

const ItemLeft = styled.div`
  width: 195px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${breakpoints.MOBILE}) {
    width: auto;
    height: 195px;
  }
`

const ItemRight = styled.div`
  flex: 1;
`

const ItemHeader = styled.p`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;

  @media (max-width: ${breakpoints.MOBILE}) {
    margin-bottom: 16px;
    text-align: center;
  }
`

const ItemText = styled.p`
  font-size: 18px;
  font-weight: 200;

  @media (max-width: ${breakpoints.MOBILE}) {
    text-align: center;
  }
`
